export function shouldShowPerformancePendingBanner({
    activeView,
    pendingRun,
    dismissedRunId,
}) {
    if (activeView !== 'overview' && activeView !== 'pos-sizing') {
        return false;
    }
    if (!pendingRun || pendingRun.status !== 'pending_apply') {
        return false;
    }
    if (!pendingRun.has_pending_state_change) {
        return false;
    }
    const pendingId = String(pendingRun.id || '').trim();
    if (!pendingId) return false;
    return pendingId !== String(dismissedRunId || '').trim();
}
